export const APPLICANT_STATUS_MAP = {
  0: '已取消',
  1: '等待预审',
  2: '预审未通过',
  3: '等待送签',
  4: '使馆审核中',
  5: '出签成功',
  6: '拒签',
  7: '退款中',
  8: '退款成功',
  9: '等待预约',
  10: '待确认',
  11: '等待接收资料',
  12: '等待培训',
  13: '待前往使馆',
  14: '拒签(待提交证明)',
  15: '拒签(等待审核)',
  16: '拒签(审核不通过)',
  17: '资料不完善(待退款)',
  18: '预约成功',
};

export const APPLICANT_IDENTITY_MAP = {
  0: '在职人员',
  1: '自由职业者',
  2: '退休人员',
  3: '在校学生',
  4: '学龄前儿童',
};

// 申请表状态
export const APPLICANTION_STATUS_MAP = {
  0: '预审已通过',
  1: '待填写',
  2: '待预审',
  3: '预审未通过',
};




// WEBPACK FOOTER //
// ./src/maps/applicant-maps.js